import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Card,
    CardContent,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem,
} from "@material-ui/core";
import PrintIcon from "@material-ui/icons/Print";
import MapContainer from "./MapContainer";
import { StyledHeader } from "../../styles";
import { Link } from "react-router-dom";
import { selectReport } from "./selectors";
import { getReport, getJobPackReports, setReport } from "./actions";
import { gridStyle, cellStyle } from "../gridHelper";

import { noImg } from "vrcore-dashboard/dist/utilities";
import ReactToPrint from "react-to-print";
import "../reports.css";
import styled from "styled-components";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
const ActionButton = styled(Button)`
    @media print {
        visibility: hidden;
    }
`;
let checkedit = "";
class SLGReport extends Component {
    constructor(props) {
        super(props);
        let path = props.location.pathname.split("/");
        this.state = {
            imageModal: false,
            selectedImg: false,
            imageText: "",
            report: false,
            editing:
                path[1] === "report-view"
                    ? false
                    : path[1] === "report-view-standalone"
                    ? false
                    : true,
            title: document.title,
            reportType: path[4].replace(/-/g, "_"),
        };
        if (path[2] === "reports") {
            props.getReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/_/g, " ").replace(/\./g, ":")
            );
        } else {
            props.getJobPackReports(
                // props.match.params.uid,
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                path[6],
                path[7].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":")
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.report !== prevProps.report) {
            this.setState({ report: this.props.report });
        }
    }
    renderText = (key, value) => {
        if (this.state.editing) {
            return (
                <TextField
                    value={this.state.report[key]}
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                />
            );
        } else {
            return value;
        }
    };
    renderDropDown = (key, value, opts) => {
        if (this.state.editing) {
            return (
                <Select
                    style={{ width: "100%" }}
                    value={
                        this.state.report[key] === ""
                            ? "N/A"
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                >
                    <MenuItem value="N/A">N/A</MenuItem>
                    {opts.map((option) => {
                        return (
                            <MenuItem value={option} key={option}>
                                {option}
                            </MenuItem>
                        );
                    })}
                </Select>
            );
        } else {
            return value === "" ? "N/A " : value;
        }
    };
    getTotal = (val) => {
        const { report } = this.state;
        let count = 0;
        report.questions &&
            report.questions.map((e) => {
                if (e.status === val) count++;
                return null;
            });
        return count;
    };
    renderSigs(attachedSigs) {
        let sigRow = 2;
        let sigCell = 1;
        let ref = "";
        return attachedSigs.map((sig, i) => {
            if (sig.signature_url.includes("https:") === false) {
                ref = "data:image/png;base64," + sig.signature_url;
            }
            let sigInfo = (
                <React.Fragment key={i}>
                    <div style={cellStyle(sigRow, sigCell, sigRow, sigCell, true)}>
                        {sig.signature_name}
                    </div>
                    <div
                        style={cellStyle(
                            sigRow,
                            sigCell + 1,
                            sigRow,
                            sigCell + 1,
                            true
                        )}
                    >
                        {sig.signature_timestamp}
                    </div>
                    {sig.signature_url.includes("https:") ? (
                        <div
                            style={cellStyle(
                                sigRow + 1,
                                sigCell,
                                sigRow + 1,
                                sigCell + 2
                            )}
                        >
                            <img
                                src={sig.signature_url}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        selectedPhoto: sig.signature_url,
                                        imageModal: true,
                                    });
                                }}
                                style={{
                                    width: 300,
                                    height: "140px",
                                    margin: "auto",
                                    cursor: "pointer",
                                }}
                            />
                        </div>
                    ) : (
                        <div
                            style={cellStyle(
                                sigRow + 1,
                                sigCell,
                                sigRow + 1,
                                sigCell + 2
                            )}
                        >
                            <img
                                src={ref}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        selectedPhoto: ref,
                                        imageModal: true,
                                    });
                                }}
                                style={{
                                    width: 300,
                                    height: 300,
                                    margin: "auto",
                                    cursor: "pointer",
                                }}
                            />
                        </div>
                    )}
                </React.Fragment>
            );
            sigCell += 2;
            if (sigCell === 9) {
                sigRow += 2;
                sigCell = 1;
            }
            return sigInfo;
        });
    }
    renderPhotos(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.photo_name}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.photo_timestamp}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.photo_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedPhoto: photo,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: 300,
                                height: 300,
                                margin: "auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }
    render() {
        let gstyle = gridStyle;
        let cstyle = cellStyle;
        // let count = this.getTotal;
        let color = this.props.color;
        let Rcount = 2;
        let Acount = 2;
        let Bcount = 2;
        let Ccount = 2;
        let Dcount = 2;
        const { report, selectedImg } = this.state;
        return (
            <Card>
                <StyledHeader style={{ background: "#0188cc" }}>
                    <Typography variant="h5" style={{ color: "white" }}>
                        TM SLG CHECKLIST
                        <ReactToPrint
                            onBeforePrint={() => {
                                setTimeout(undefined, 4000);
                                document.title =
                                    "TM SLG CHECKLIST" +
                                    this.props.match.params.report_id
                                        .replace(/_/g, " ")
                                        .replace(/\./g, ":");
                            }}
                            onAfterPrint={() => {
                                document.title = this.state.title;
                            }}
                            trigger={() => (
                                <PrintIcon
                                    style={{
                                        float: "right",
                                        fontSize: "36px",
                                        marginRight: "30px",
                                        cursor: "pointer",
                                    }}
                                />
                            )}
                            content={() => this.componentRef}
                            debug={true}
                        />
                    </Typography>
                </StyledHeader>
                <CardContent>
                    {report && (
                        <>
                            <div ref={(el) => (this.componentRef = el)}>
                                {this.props.header && <this.props.header />}
                                <div
                                    className="imgDiv"
                                    style={{
                                        float: "left",
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Typography variant="h5">
                                        TM SLG CHECKLIST
                                    </Typography>
                                </div>

                                <div style={{ width: "100%" }}>
                                    <div
                                        style={{ width: "60%", float: "left" }}
                                    >
                                        <div style={gstyle(7, 13, null, color)}>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    13,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Report Details</b>
                                            </div>
                                            <div style={cstyle(2, 1, 2, 6)}>
                                                <b>Name:</b> &nbsp;
                                                {report.user_name
                                                    ? report.user_name
                                                    : ""}
                                            </div>
                                            <div style={cstyle(2, 6, 2, 13)}>
                                                <b>Job Name.:</b>&nbsp;
                                                {report.job_name
                                                    ? report.job_name
                                                    : ""}
                                            </div>
                                            <div style={cstyle(3, 1, 3, 13)}>
                                                <b>Contract Number:&nbsp;</b>{" "}
                                                {report.contract_number
                                                    ? report.contract_number
                                                    : ""}
                                            </div>
                                            <div style={cstyle(4, 1, 4, 13)}>
                                                <b>Phase: </b>&nbsp;
                                                {report.phase
                                                    ? report.phase
                                                    : ""}
                                            </div>
                                            <div style={cstyle(5, 1, 5, 13)}>
                                                <b>Job Address: </b>&nbsp;{" "}
                                                {report.job_address
                                                    ? report.job_address
                                                    : ""}
                                            </div>
                                            <div style={cstyle(6, 1, 6, 13)}>
                                                <b>Check Time: </b>&nbsp;{" "}
                                                {report.check_time
                                                    ? report.check_time
                                                    : ""}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            width: "38%",
                                            float: "left",
                                            marginLeft: "2%",
                                        }}
                                    >
                                        <MapContainer
                                            lat={+report.location_lat}
                                            long={+report.location_lon}
                                            style={{ width: "80%" }}
                                        />
                                        <br />
                                        <br />
                                    </div>
                                </div>
                                {/* <div style={{ width: "100%", clear: "both" }}>
                                    <div style={gstyle(12, 2)}>
                                        <div
                                            style={cstyle(1, 1, 1, 2, false, true)}
                                        >
                                            <b>Result Summary</b>
                                        </div>

                                        <div style={cstyle(2, 1, 4, 4, true)}>
                                            <p style={{ color: "green" }}>Good Order<FiberManualRecordIcon
                                                style={{
                                                    color: "green"
                                                }}
                                            /></p>&nbsp;&nbsp;&nbsp;&nbsp;{count("Green")}
                                        </div>
                                        <div style={cstyle(2, 4, 4, 8, true)}>
                                            <p style={{ color: "red" }}>Immediate Action<FiberManualRecordIcon
                                                style={{
                                                    color: "red"
                                                }}
                                            /></p>&nbsp;&nbsp;&nbsp;&nbsp;{count("Red")}
                                        </div>
                                        <div style={cstyle(2, 8, 4, 12, true)}>
                                            <p style={{ color: "#FFBF00" }}>Improvements Needed<FiberManualRecordIcon
                                                style={{
                                                    color: "#FFBF00"
                                                }}
                                            /></p>&nbsp;&nbsp;&nbsp;&nbsp;{count("Amber")}
                                        </div>
                                        <div style={cstyle(2, 12, 4, 16, true)}>
                                            <p style={{ color: "grey" }}>Not Applicable<FiberManualRecordIcon
                                                style={{
                                                    color: "grey"
                                                }}
                                            /></p>&nbsp;&nbsp;&nbsp;&nbsp;{count("N/A")}
                                        </div>
                                    </div>
                                </div> */}
                                 <div style={{ width: "100%", clear: "both" }}>
                                 <div style={gstyle(12, 2)}>
                                 <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Installation Checks</b>
                                            </div>
                                            <div style={cstyle(2, 1, 2, 2)}>
                                            <b>Question</b>
                                            </div>
                                            <div style={cstyle(2, 2, 2, 3)}>
                                            <b>Status</b>
                                            </div>
                                            <div style={cstyle(2, 3, 2, 4)}>
                                            <b>Describe Defect</b>
                                            </div>
                                            <div style={cstyle(2, 4, 2, 5)}>
                                            <b>Photo</b>
                                            </div>
                                            
                                     
                                        {
                                            report.sections.map((a,i) => {
                                                if(i===0){
                                                    return a.items.map((f,i) => {
                                                        Rcount++
                                                            return(
                                                                <React.Fragment key={Rcount}>
                                                                       <div
                                                                style={cellStyle(
                                                                    Rcount,
                                                                    1,
                                                                    Rcount,
                                                                    2
                                                                )}
                                                            >
                                                                {f.question?f.question:"N/A"}
                                                            </div>
                                                            <div
                                                                    style={cstyle(
                                                                        Rcount,
                                                                        2,
                                                                        Rcount,
                                                                        3
                                                                    )}
                                                                >
                                                                    {f.status
                                                                        ? f.status
                                                                        : "N/A"}
                                                                </div>
                                                                <div
                                                                    style={cstyle(
                                                                        Rcount,
                                                                        3,
                                                                        Rcount,
                                                                        4
                                                                    )}
                                                                >
                                                                    {f.describe_defect
                                                                        ? f.describe_defect
                                                                        : "N/A"}
                                                                </div>
                                                                <div
                                                                    style={cstyle(
                                                                        Rcount,
                                                                        3,
                                                                        Rcount,
                                                                        4
                                                                    )}
                                                                >
                                                                    {f.describe_defect
                                                                        ? f.describe_defect
                                                                        : "N/A"}
                                                                </div>
                                                                <div
                                                                    style={cstyle(
                                                                        Rcount,
                                                                        4,
                                                                        Rcount,
                                                                        5
                                                                    )}
                                                                >
                                                                    {f.attached_photo && (
                                                                        <img
                                                                            src={
                                                                                f.attached_photo
                                                                                    .photo_url
                                                                            }
                                                                            alt="Site "
                                                                            onClick={() => {
                                                                                this.setState(
                                                                                    {
                                                                                        selectedImg:
                                                                                            f
                                                                                            .attached_photo
                                                                                                .photo_url,
                                                                                        imageModal: true,
                                                                                    }
                                                                                );
                                                                            }}
                                                                            style={{
                                                                                width:
                                                                                    "auto",
                                                                                height:
                                                                                    "90px",
                                                                                margin:
                                                                                    "auto",
                                                                                cursor:
                                                                                    "pointer",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                                </React.Fragment>
                                                            )
                                                        })
                                                }
                                              return null;
                                            })
                                        }
                                     </div>
                                 </div>
                                 <div style={{ width: "100%", clear: "both" }}>
                                 <div style={gstyle(12, 2)}>
                                 <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Operation Checks</b>
                                            </div>
                                            <div style={cstyle(2, 1, 2, 2)}>
                                            <b>Question</b>
                                            </div>
                                            <div style={cstyle(2, 2, 2, 3)}>
                                            <b>Status</b>
                                            </div>
                                            <div style={cstyle(2, 3, 2, 4)}>
                                            <b>Describe Defect</b>
                                            </div>
                                            <div style={cstyle(2, 4, 2, 5)}>
                                            <b>Photo</b>
                                            </div>
                                            
                                     
                                        {
                                            report.sections.map((a,i) => {
                                                if(i===1){
                                                    return a.items.map((f,i) => {
                                                        Acount++
                                                            return(
                                                                <React.Fragment key={Acount}>
                                                                       <div
                                                                style={cellStyle(
                                                                    Acount,
                                                                    1,
                                                                    Acount,
                                                                    2
                                                                )}
                                                            >
                                                                {f.question?f.question:"N/A"}
                                                            </div>
                                                            <div
                                                                    style={cstyle(
                                                                        Acount,
                                                                        2,
                                                                        Acount,
                                                                        3
                                                                    )}
                                                                >
                                                                    {f.status
                                                                        ? f.status
                                                                        : "N/A"}
                                                                </div>
                                                                <div
                                                                    style={cstyle(
                                                                        Acount,
                                                                        3,
                                                                        Acount,
                                                                        4
                                                                    )}
                                                                >
                                                                    {f.describe_defect
                                                                        ? f.describe_defect
                                                                        : "N/A"}
                                                                </div>
                                                                <div
                                                                    style={cstyle(
                                                                        Acount,
                                                                        3,
                                                                        Acount,
                                                                        4
                                                                    )}
                                                                >
                                                                    {f.describe_defect
                                                                        ? f.describe_defect
                                                                        : "N/A"}
                                                                </div>
                                                                <div
                                                                    style={cstyle(
                                                                        Acount,
                                                                        4,
                                                                        Acount,
                                                                        5
                                                                    )}
                                                                >
                                                                    {f.attached_photo && (
                                                                        <img
                                                                            src={
                                                                                f.attached_photo
                                                                                    .photo_url
                                                                            }
                                                                            alt="Site "
                                                                            onClick={() => {
                                                                                this.setState(
                                                                                    {
                                                                                        selectedImg:
                                                                                            f
                                                                                            .attached_photo
                                                                                                .photo_url,
                                                                                        imageModal: true,
                                                                                    }
                                                                                );
                                                                            }}
                                                                            style={{
                                                                                width:
                                                                                    "auto",
                                                                                height:
                                                                                    "90px",
                                                                                margin:
                                                                                    "auto",
                                                                                cursor:
                                                                                    "pointer",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                                </React.Fragment>
                                                            )
                                                        })
                                                }
                                              return null;
                                            })
                                        }
                                     </div>
                                 </div>
                                 <div style={{ width: "100%", clear: "both" }}>
                                 <div style={gstyle(12, 2)}>
                                 <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Traffic Checks</b>
                                            </div>
                                            <div style={cstyle(2, 1, 2, 2)}>
                                            <b>Question</b>
                                            </div>
                                            <div style={cstyle(2, 2, 2, 3)}>
                                            <b>Status</b>
                                            </div>
                                            <div style={cstyle(2, 3, 2, 4)}>
                                            <b>Describe Defect</b>
                                            </div>
                                            <div style={cstyle(2, 4, 2, 5)}>
                                            <b>Photo</b>
                                            </div>
                                            
                                     
                                        {
                                            report.sections.map((a,i) => {
                                                if(i===2){
                                                    return a.items.map((f,i) => {
                                                        Bcount++
                                                            return(
                                                                <React.Fragment key={Bcount}>
                                                                       <div
                                                                style={cellStyle(
                                                                    Bcount,
                                                                    1,
                                                                    Bcount,
                                                                    2
                                                                )}
                                                            >
                                                                {f.question?f.question:"N/A"}
                                                            </div>
                                                            <div
                                                                    style={cstyle(
                                                                        Bcount,
                                                                        2,
                                                                        Bcount,
                                                                        3
                                                                    )}
                                                                >
                                                                    {f.status
                                                                        ? f.status
                                                                        : "N/A"}
                                                                </div>
                                                                <div
                                                                    style={cstyle(
                                                                        Bcount,
                                                                        3,
                                                                        Bcount,
                                                                        4
                                                                    )}
                                                                >
                                                                    {f.describe_defect
                                                                        ? f.describe_defect
                                                                        : "N/A"}
                                                                </div>
                                                                <div
                                                                    style={cstyle(
                                                                        Bcount,
                                                                        3,
                                                                        Bcount,
                                                                        4
                                                                    )}
                                                                >
                                                                    {f.describe_defect
                                                                        ? f.describe_defect
                                                                        : "N/A"}
                                                                </div>
                                                                <div
                                                                    style={cstyle(
                                                                        Bcount,
                                                                        4,
                                                                        Bcount,
                                                                        5
                                                                    )}
                                                                >
                                                                    {f.attached_photo && (
                                                                        <img
                                                                            src={
                                                                                f.attached_photo
                                                                                    .photo_url
                                                                            }
                                                                            alt="Site "
                                                                            onClick={() => {
                                                                                this.setState(
                                                                                    {
                                                                                        selectedImg:
                                                                                            f
                                                                                            .attached_photo
                                                                                                .photo_url,
                                                                                        imageModal: true,
                                                                                    }
                                                                                );
                                                                            }}
                                                                            style={{
                                                                                width:
                                                                                    "auto",
                                                                                height:
                                                                                    "90px",
                                                                                margin:
                                                                                    "auto",
                                                                                cursor:
                                                                                    "pointer",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                                </React.Fragment>
                                                            )
                                                        })
                                                }
                                              return null;
                                            })
                                        }
                                     </div>
                                 </div>
                                 <div style={{ width: "100%", clear: "both" }}>
                                 <div style={gstyle(12, 2)}>
                                 <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Pedestrian & Vulnerable User Checks</b>
                                            </div>
                                            <div style={cstyle(2, 1, 2, 2)}>
                                            <b>Question</b>
                                            </div>
                                            <div style={cstyle(2, 2, 2, 3)}>
                                            <b>Status</b>
                                            </div>
                                            <div style={cstyle(2, 3, 2, 4)}>
                                            <b>Describe Defect</b>
                                            </div>
                                            <div style={cstyle(2, 4, 2, 5)}>
                                            <b>Photo</b>
                                            </div>
                                            
                                     
                                        {
                                            report.sections.map((a,i) => {
                                                if(i===3){
                                                    return a.items.map((f,i) => {
                                                        Ccount++
                                                            return(
                                                                <React.Fragment key={Ccount}>
                                                                       <div
                                                                style={cellStyle(
                                                                    Ccount,
                                                                    1,
                                                                    Ccount,
                                                                    2
                                                                )}
                                                            >
                                                                {f.question?f.question:"N/A"}
                                                            </div>
                                                            <div
                                                                    style={cstyle(
                                                                        Ccount,
                                                                        2,
                                                                        Ccount,
                                                                        3
                                                                    )}
                                                                >
                                                                    {f.status
                                                                        ? f.status
                                                                        : "N/A"}
                                                                </div>
                                                                <div
                                                                    style={cstyle(
                                                                        Ccount,
                                                                        3,
                                                                        Ccount,
                                                                        4
                                                                    )}
                                                                >
                                                                    {f.describe_defect
                                                                        ? f.describe_defect
                                                                        : "N/A"}
                                                                </div>
                                                                <div
                                                                    style={cstyle(
                                                                        Ccount,
                                                                        3,
                                                                        Ccount,
                                                                        4
                                                                    )}
                                                                >
                                                                    {f.describe_defect
                                                                        ? f.describe_defect
                                                                        : "N/A"}
                                                                </div>
                                                                <div
                                                                    style={cstyle(
                                                                        Ccount,
                                                                        4,
                                                                        Ccount,
                                                                        5
                                                                    )}
                                                                >
                                                                    {f.attached_photo && (
                                                                        <img
                                                                            src={
                                                                                f.attached_photo
                                                                                    .photo_url
                                                                            }
                                                                            alt="Site "
                                                                            onClick={() => {
                                                                                this.setState(
                                                                                    {
                                                                                        selectedImg:
                                                                                            f
                                                                                            .attached_photo
                                                                                                .photo_url,
                                                                                        imageModal: true,
                                                                                    }
                                                                                );
                                                                            }}
                                                                            style={{
                                                                                width:
                                                                                    "auto",
                                                                                height:
                                                                                    "90px",
                                                                                margin:
                                                                                    "auto",
                                                                                cursor:
                                                                                    "pointer",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                                </React.Fragment>
                                                            )
                                                        })
                                                }
                                              return null;
                                            })
                                        }
                                     </div>
                                 </div>
                                 <div style={{ width: "100%", clear: "both" }}>
                                 <div style={gstyle(12, 2)}>
                                 <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Work Complete Checks</b>
                                            </div>
                                            <div style={cstyle(2, 1, 2, 2)}>
                                            <b>Question</b>
                                            </div>
                                            <div style={cstyle(2, 2, 2, 3)}>
                                            <b>Status</b>
                                            </div>
                                            <div style={cstyle(2, 3, 2, 4)}>
                                            <b>Describe Defect</b>
                                            </div>
                                            <div style={cstyle(2, 4, 2, 5)}>
                                            <b>Photo</b>
                                            </div>
                                            
                                     
                                        {
                                            report.sections.map((a,i) => {
                                                if(i===4){
                                                    return a.items.map((f,i) => {
                                                        Dcount++
                                                            return(
                                                                <React.Fragment key={Dcount}>
                                                                       <div
                                                                style={cellStyle(
                                                                    Dcount,
                                                                    1,
                                                                    Dcount,
                                                                    2
                                                                )}
                                                            >
                                                                {f.question?f.question:"N/A"}
                                                            </div>
                                                            <div
                                                                    style={cstyle(
                                                                        Dcount,
                                                                        2,
                                                                        Dcount,
                                                                        3
                                                                    )}
                                                                >
                                                                    {f.status
                                                                        ? f.status
                                                                        : "N/A"}
                                                                </div>
                                                                <div
                                                                    style={cstyle(
                                                                        Dcount,
                                                                        3,
                                                                        Dcount,
                                                                        4
                                                                    )}
                                                                >
                                                                    {f.describe_defect
                                                                        ? f.describe_defect
                                                                        : "N/A"}
                                                                </div>
                                                                <div
                                                                    style={cstyle(
                                                                        Dcount,
                                                                        3,
                                                                        Dcount,
                                                                        4
                                                                    )}
                                                                >
                                                                    {f.describe_defect
                                                                        ? f.describe_defect
                                                                        : "N/A"}
                                                                </div>
                                                                <div
                                                                    style={cstyle(
                                                                        Dcount,
                                                                        4,
                                                                        Dcount,
                                                                        5
                                                                    )}
                                                                >
                                                                    {f.attached_photo && (
                                                                        <img
                                                                            src={
                                                                                f.attached_photo
                                                                                    .photo_url
                                                                            }
                                                                            alt="Site "
                                                                            onClick={() => {
                                                                                this.setState(
                                                                                    {
                                                                                        selectedImg:
                                                                                            f
                                                                                            .attached_photo
                                                                                                .photo_url,
                                                                                        imageModal: true,
                                                                                    }
                                                                                );
                                                                            }}
                                                                            style={{
                                                                                width:
                                                                                    "auto",
                                                                                height:
                                                                                    "90px",
                                                                                margin:
                                                                                    "auto",
                                                                                cursor:
                                                                                    "pointer",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                                </React.Fragment>
                                                            )
                                                        })
                                                }
                                              return null;
                                            })
                                        }
                                     </div>
                                 </div>
                                 <div style={gstyle(4, 9, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Notes Section</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 13)}>
                                                <b>Notes:</b> &nbsp;{report.notes
                                                    ? report.notes
                                                    : ""}
                                            </div>
                                </div>
                                <div style={gstyle(4, 9, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Checks Completed By</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 13)}>
                                    {report.checks_completed_by?report.checks_completed_by:""}
                                    </div>
                                            
                                </div>
                                <div style={gstyle(4, 9, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Attached Signatures</b>
                                    </div>
                                    {report.attached_signatures &&
                                        this.renderSigs(
                                            report.attached_signatures
                                        )}
                                </div>
                            </div>
                        </>
                    )}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {this.state.editing &&
                            checkedit === "report-edit-jobpack" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-edit-jobpack",
                                        "report-view"
                                    )}
                                >
                                    <div>
                                        <ActionButton
                                            style={{ marginRight: 10 }}
                                            onClick={() => {
                                                this.props.setReport(
                                                    this.state.report,
                                                    this.props.location.pathname
                                                );
                                            }}
                                            variant="contained"
                                            color="primary"
                                        >
                                            Submit
                                        </ActionButton>
                                        <ActionButton
                                            color="secondary"
                                            variant="contained"
                                        >
                                            Cancel
                                        </ActionButton>
                                    </div>
                                </Link>
                            )}

                        {!this.state.editing && checkedit === "report-view" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-view",
                                    "report-edit-jobpack"
                                )}
                            >
                                <ActionButton
                                    variant="contained"
                                    color="primary"
                                >
                                    Edit
                                </ActionButton>
                            </Link>
                        )}
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {this.state.editing && checkedit === "report-edit" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-edit",
                                    "report-view-standalone"
                                )}
                            >
                                <div>
                                    <ActionButton
                                        style={{ marginRight: 10 }}
                                        onClick={() => {
                                            this.props.setReport(
                                                this.state.report,
                                                this.props.location.pathname
                                            );
                                        }}
                                        variant="contained"
                                        color="primary"
                                    >
                                        Submit
                                    </ActionButton>
                                    <ActionButton
                                        color="secondary"
                                        variant="contained"
                                    >
                                        Cancel
                                    </ActionButton>
                                </div>
                            </Link>
                        )}

                        {!this.state.editing &&
                            checkedit === "report-view-standalone" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-view-standalone",
                                        "report-edit"
                                    )}
                                >
                                    <ActionButton
                                        variant="contained"
                                        color="primary"
                                    >
                                        Edit
                                    </ActionButton>
                                </Link>
                            )}
                    </div>
                    {report && (
                        <Modal isOpen={this.state.imageModal}>
                            <ModalHeader
                                style={{
                                    color:
                                        this.state.imageText ===
                                        "Action Required"
                                            ? "red"
                                            : "green",
                                }}
                            >
                                {this.state.imageText}
                            </ModalHeader>
                            <ModalBody style={{ margin: "auto" }}>
                                <img
                                    src={
                                        selectedImg === undefined ||
                                        selectedImg === null ||
                                        selectedImg === ""
                                            ? noImg
                                            : selectedImg
                                    }
                                    alt="Site"
                                    style={{ width: "350px", height: "350px" }}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        this.setState({
                                            selectedImg: false,
                                            imageModal: false,
                                            imageText: "",
                                        });
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    )}
                </CardContent>
            </Card>
        );
    }
}
export default connect(
    (store) => {
        return { report: selectReport(store) };
    },
    { getReport, setReport, getJobPackReports }
)(SLGReport);
